export type MaterialId = 'concrete' | 'metal' | 'absorbent'

export interface Material {
  id: MaterialId
  label: string
  /** Absorption coefficient around 250 Hz (energy, 0..1). */
  absLow: number
  /** Absorption coefficient around 4 kHz (energy, 0..1). */
  absHigh: number
  /** Loss in dB when a path passes through ~25 cm of this material. */
  transmissionDb: number
  /** Lowpass corner (Hz) applied to sound transmitted through the material. */
  transmissionCutoff: number
  /** Viewport colour. */
  color: number
}

export const MATERIALS: Record<MaterialId, Material> = {
  concrete: {
    id: 'concrete',
    label: 'Concrete',
    absLow: 0.01,
    absHigh: 0.03,
    transmissionDb: 34,
    transmissionCutoff: 700,
    color: 0x8d8a84,
  },
  metal: {
    id: 'metal',
    label: 'Metal',
    absLow: 0.04,
    absHigh: 0.03,
    transmissionDb: 26,
    transmissionCutoff: 1400,
    color: 0x6f7a82,
  },
  absorbent: {
    id: 'absorbent',
    label: 'Absorbent',
    absLow: 0.35,
    absHigh: 0.92,
    transmissionDb: 12,
    transmissionCutoff: 900,
    color: 0x4f4a3f,
  },
}

export const MATERIAL_IDS = Object.keys(MATERIALS) as MaterialId[]
